export function removePrices(planName: string): string {
  const priceRegex = /\$((?:\d|,)*\.?\d+)/g;
  return planName.replace(priceRegex, '').trim().replace(/\s\s+/g, ' ');
}

// priceRegex will match any price number Ex. [$99, $.99, $9.99, $9,999, $9,999.99] and replace with ''
// The subsequent trim and replace will ensure that leading and trailing white-space is removed and only a maximum of one space is allowed between words
